function getConvertedDate(date) {
    return new Date(
        date.toLocaleString("en-US", {
            timeZone: "Europe/London",
        })
    );
}

function isToday(date) {
    var today = getConvertedDate(new Date());
    if (today.toDateString() === date.toDateString()) {
        return true;
    }
    return false;
}

function isTomorrow(date) {
    var tomorrow = getConvertedDate(new Date());
    tomorrow.setDate(tomorrow.getDate() + 1);
    if (tomorrow.toDateString() === date.toDateString()) {
        return true;
    }
    return false;
}

function formatDate(date) {
    return date
        .toLocaleDateString("en-GB", {
            weekday: "short",
            month: "long",
            day: "numeric",
        })
        .replace(/,/g, "");
}

function isSlotAvailableToday(slots) {
    
    let nextAppointment = "";
    const now = getConvertedDate(new Date());

    for (var key in slots) {

        let slot = slots[key];

        if(
            slot.morning ||
            slot.afternoon ||
            slot.evening
        ) {
            let slotDate = new Date(slot.date);
            if( slotDate.getTime > now.getTime() ) {
                nextAppointment = "Today";
                return false;
            }

        }
        return true;
    }

    return nextAppointment;
}


function getNextAppointmentDate(dates) {

    if(dates.length < 1) {
        return 'NA';
    }

    let nextAppointment = Object.keys(dates)[0];
    let nextApointmentDate = getConvertedDate(new Date(nextAppointment));

    if( isToday(nextApointmentDate) ) {

        if( isSlotAvailableToday(Object.values(dates)[0]) ) {
            return "Today";
        } else {
            let nextAppointment = Object.keys(dates)[1];

            if(!nextAppointment) {
                return "NA";
            }

            if (isTomorrow(getConvertedDate(new Date(nextAppointment)))) {
                return 'Tomorrow';
            } else {
                return formatDate(new Date(nextAppointment));
            }
        }

    } else if ( isTomorrow(nextApointmentDate) ) {
        return 'Tomorrow';
    } else {
        return formatDate(new Date(nextAppointment));
    }

    return 'NA';
}

export { getNextAppointmentDate };